// usePushNotifications2.ts
// src/hooks/usePushNotifications.ts
import axios from '../api/axiosSetup3';
import { useEffect, useState } from 'react';

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

export const usePushNotifications = () => {
  const [subscription, setSubscription] = useState<PushSubscription | null>(null);
  const [permission, setPermission] = useState<NotificationPermission>(Notification.permission);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  // Восстановить существующую подписку при монтировании
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.register('/sw.js');

    navigator.serviceWorker.ready.then((reg) => {
      reg.pushManager.getSubscription().then((sub) => {
        if (sub) setSubscription(sub);
      });
    });
  }, []);

  const subscribe = async () => {
    setError(null);
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const key = await axios.get('https://count.aipeeper.com/api/push/key/');
      console.log('Service Worker ready, VAPID key fetched:', key.data);
      // console.log('VAPID key from server:', key.data);

      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        // applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
        applicationServerKey: key.data?.public_key ? urlBase64ToUint8Array(key.data.public_key) : undefined,
      });
      console.log('Push subscription successful:', sub);

      setSubscription(sub);
      setPermission(Notification.permission);

      const subJson = sub.toJSON(); // { endpoint, keys: { p256dh, auth } }
      
      // await fetch('http://localhost:3001/push/subscribe', {
      console.log('Sending subscription to server:', subJson);
      await axios.post('https://count.aipeeper.com/api/push/subscribe/', subJson, );
      console.log('Subscription sent to server');
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Subscribe failed'));
      throw err; // пробрасываем, если компонент тоже хочет реагировать      
    } finally {
      setLoading(false);
    }
  };

  const unsubscribe = async () => {
    if (!subscription) 
        return;

    setError(null);
    setLoading(true);
    try {
      await subscription.unsubscribe();           // браузер

      // await fetch('/api/unsubscribe', {           // сервер
      // await fetch('http://localhost:3001/push/unsubscribe', {



      // await fetch('https://count.aipeeper.com/api/push/unsubscribe/', {
      //   method: 'POST',
      //   // method: 'DELETE',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ endpoint: subscription.endpoint }),
      // });

      await axios.post('https://count.aipeeper.com/api/push/unsubscribe/', {
        body: JSON.stringify({ endpoint: subscription.endpoint })
        },
      );

      setSubscription(null);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Unsubscribe failed'));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { 
    subscribe, 
    unsubscribe, 
    subscription, 
    permission, 
    loading, 
    error, 
  };
};